import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "cog_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 2h3l.37 2.22a7.953 7.953 0 0 1 2.309.957l1.831-1.309 2.122 2.122-1.309 1.831c.433.705.76 1.482.957 2.309l2.22.37v3l-2.22.37a7.954 7.954 0 0 1-.957 2.309l1.309 1.831-2.122 2.122-1.831-1.309a7.954 7.954 0 0 1-2.309.957L13.5 22h-3l-.37-2.22a7.954 7.954 0 0 1-2.309-.957L5.99 20.132 3.868 18.01l1.309-1.831a7.953 7.953 0 0 1-.957-2.309L2 13.5v-3l2.22-.37a7.953 7.953 0 0 1 .957-2.309L3.868 5.99 5.99 3.868 7.82 5.177a7.953 7.953 0 0 1 2.309-.957L10.5 2ZM12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }